// Libraries
import { action, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";
import { ColourSelection, SortDirection } from "Custom/Models";
import * as utils from "Custom/Utils";
import { IsNegative, IsNotEmpty, ValidatePromise } from "class-validator";

export class Delcote10Model extends ModelBase<Delcote10Model, Delcote10ModelDTO> {
    constructor() {
        super();
    }

    // #region Model Properties
    @observable
    public endlapMeterage: number = 0;

    @observable
    public fixingCount: number = 0;

    @observable
    public overlapMeterage: number = 0;

    @observable
    public profileCorrectionPercentage: number = 20;

    @observable
    public ridgeFlashingsEtcMeterage: number = 0;

    @observable
    public rooflightSquareMeterage: number = 0;

    @observable
    @utils.MinusGtrZero("rooflightSquareMeterage", {
        message: "Cannot be negative",
    })
    @ValidatePromise()
    public roofSquareMeterage: number = 0;

    @observable
    public topcoatColours = observable<ColourSelection>([]);

    @observable
    @IsNotEmpty({ message: "Topcoat colour is required" })
    public topcoatColourSelection: ColourSelection | undefined = undefined;

    @action
    public setTopcoatColourSelection = (newColour: ColourSelection | undefined): void => {
        this.topcoatColourSelection = newColour;
    };

    // #endregion Model Properties

    @action
    public fromProductDataDto(topcoatColours: any[]): void {
        if (topcoatColours.length > 0) {
            this.topcoatColours.replace([]);
            let local: ColourSelection[] = [];
            let specialColours: ColourSelection[] = [];
            for (const colour of topcoatColours) {
                if (colour.variantId === -1) {
                    specialColours.push({
                        title: colour.variantName,
                        value: colour.variantId,
                        group: "Special colours",
                    });
                } else {
                    local.push({
                        title: colour.variantName,
                        value: colour.variantId,
                        group: "Colours",
                    });
                }
            }

            this.topcoatColours.replace(utils.sortBy(local, "title", SortDirection.Asc));
            this.topcoatColours.push(...utils.sortBy(specialColours, "title", SortDirection.Asc));
        }
    }

    @action
    public fromDto(model: Delcote10ModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): Delcote10ModelDTO {
        return {
            endlapMeterage: this.endlapMeterage,
            fixingCount: this.fixingCount,
            overlapMeterage: this.overlapMeterage,
            profileCorrectionPercentage: this.profileCorrectionPercentage,
            ridgeFlashingsEtcMeterage: this.ridgeFlashingsEtcMeterage,
            rooflightSquareMeterage: this.rooflightSquareMeterage,
            roofSquareMeterage: this.roofSquareMeterage,
            colourId: this.topcoatColourSelection!.value,
            colourName: this.topcoatColourSelection!.title,
            version: 2,
        };
    }
}

export interface Delcote10ModelDTO {
    endlapMeterage: number;
    fixingCount: number;
    overlapMeterage: number;
    profileCorrectionPercentage: number;
    ridgeFlashingsEtcMeterage: number;
    rooflightSquareMeterage: number;
    roofSquareMeterage: number;
    colourId: number;
    colourName: string;
    version: number;
}
